webpackJsonp([244766697315142],{

/***/ 3050:
/***/ (function(module, exports) {

	module.exports = {"data":{"services":{"edges":[{"node":{"type":"community-clinic-or-program","phone_number":"95159000","service_type":null,"discipline":"","disorders_treated":"Binge Eating Disorder, Body Dysmorphic Disorder","age_inclusion":"Adults (18 years and over)","treatment_days":null,"other_requirements":null,"attachments":null,"title":"Camperdown Community Mental Health Service","description":"Provide mental health support and treatment for people with chronic and enduring mental illness","fax_number":null,"website":"http://slhd.health.nsw.gov.au","email":"linda.muir@health.nsw.gov.au","street_address_1":"King George V Building, Missenden Road, Camperdown NSW 2050","suburb":"Camperdown","postcode":"2050","state":"NSW","latitude":-33.8896174,"longitude":151.181697,"fields":null}}]}},"pathContext":{"id":"/opt/build/repo/gatsby/content/treatment-services/camperdown-community-mental-health-service.json absPath of file >>> JSON"}}

/***/ })

});


// WEBPACK FOOTER //
// path---treatment-services-camperdown-community-mental-health-service-fff74d57a9669d0c5642.js